import { render, staticRenderFns } from "./examenesShow.vue?vue&type=template&id=afe1a2a2"
import script from "./examenesShow.vue?vue&type=script&lang=js"
export * from "./examenesShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports